import type { FetchLiveAuctionsConfigResponse } from '@/redux/api/config';
import type { PubSubProvider } from '@/types/PubSubProvider';
import type { TypedActionWithPayload } from '@/types/redux';

export const UPDATE_MESSAGING_PROVIDER = 'UPDATE_MESSAGING_PROVIDER';
export type UPDATE_MESSAGING_PROVIDER_ACTION = TypedActionWithPayload<
    typeof UPDATE_MESSAGING_PROVIDER,
    {
        provider: PubSubProvider;
    }
>;

export const LOAD_LIVE_CATALOGS_CONFIG_SUCCESS = 'LOAD_LIVE_CATALOGS_CONFIG_SUCCESS';
export type LOAD_LIVE_CATALOGS_CONFIG_SUCCESS_ACTION = TypedActionWithPayload<
    typeof LOAD_LIVE_CATALOGS_CONFIG_SUCCESS,
    FetchLiveAuctionsConfigResponse
>;
